import { render, staticRenderFns } from "./config_charts.vue?vue&type=template&id=cedf61f0&scoped=true"
import script from "./config_charts.vue?vue&type=script&lang=js"
export * from "./config_charts.vue?vue&type=script&lang=js"
import style0 from "./config_charts.vue?vue&type=style&index=0&id=cedf61f0&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cedf61f0",
  null
  
)

export default component.exports